<template>
  <main class="main main--error">
    <div class="group group--sidebar group--last group--df-column group--flex">
      <h1 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="p" 
        v-html="errorMessage" />

      <p class="p mb0">We can help you by phone:</p>
      <a class="tdn" :href="`tel:${number}`"><h2 
        :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
        class="h1 mt0">{{ number }}</h2></a>

      <p class="p">A Carelon team member is available <br>24 hours a day, 7 days a week.</p>

      <module-button
        class="mw220"
        button="primary"
        :link="link"
      >
        {{ buttonText }}
      </module-button>
    </div>
  </main>
</template>

<script>
// Vuex
import { mapGetters, mapActions } from 'vuex';

import phone from 'utils/phone';

// Export
export default {
  name: 'view-error',

  
  // Computed
  computed: {
    ...mapGetters('app', [
      'org',
      'errorMessage',
      'errorRedirectLink',
      'errorRedirectLabel',
    ]),
    ...mapGetters('auth', ['isAuthenticated']),

    number() {
      return phone(this.org.phone);
    },

    link() {
      return this.errorRedirectLink || 'home';
    },

    buttonText() {
      return this.errorRedirectLabel || 'Go back';
    },
  },


  // Methods
  methods: {
    ...mapActions('app', ['setErrorMessage', 'setErrorRedirect']),
  },


  // Lifecycles
  destroyed() {
    this.setErrorMessage(''); 
    this.setErrorRedirect('');
  },
};
</script>



// WEBPACK FOOTER //
// Error.vue?73afa678